import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VoucherQualifier } from '@app/cart/services/voucher-qualifiers/data';
import { catchError, map, take } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';


@Injectable({
    providedIn: 'root'
})
export class VoucherQualifiersService {

    state = true;
    constructor(private http: HttpClient) { }

    getOrderQualifiers(voucherReference: string): Observable<VoucherQualifier[]> {
        const url = `${environment.csBaseURL}/vouchers/${voucherReference}/qualifiers`;
        const fromObject = { levels: 'ORDER,ORDER_LINE,SAMPLING' };
        const params = new HttpParams({ fromObject });
        return this.http.get<VoucherQualifier[]>(url, { params }).pipe(
            catchError(e => []) // swallow. should log to somewhere
        );
    }
}
